import { useCallback, useEffect } from 'react';
import Raven from 'raven-js';
import enviro from 'enviro';
import { registerMutation, useMutation } from 'data-fetching-client';

import { authorizeUberconference } from '../uberconferenceApi';

const AUTHORIZE_UBERCONFERENCE = registerMutation({
  fieldName: 'authorizeUberconference',
  args: ['code'],
  fetcher: authorizeUberconference,
});

export const useAuthorizeUberconference = () => {
  const [authorize, { loading, error }] = useMutation(AUTHORIZE_UBERCONFERENCE);

  useEffect(() => {
    if (error) {
      if (enviro.isQa()) {
        console.error(error);
      }
      Raven.captureException(error, {
        extra: { message: 'Error on authentication of Uberconference' },
      });
    }
  }, [error]);

  const authorizeAccount = useCallback(
    (code: string) => {
      return authorize({
        variables: {
          code,
        },
      });
    },
    [authorize]
  );

  return {
    authorizeAccount,
    updating: loading,
    error,
  };
};
